var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "22 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37.421,28.752h6.628c.366,0,.663.297.663.663v15.906c0,.366-.297.663-.663.663h-6.628c-.366,0-.663-.297-.663-.663v-15.906c0-.366.297-.663.663-.663Z",
    fill: "#f3c144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.336,14.172h6.628c.366,0,.663.297.663.663v30.487c0,.366-.297.663-.663.663h-6.628c-.366,0-.663-.297-.663-.663V14.834c0-.366.297-.663.663-.663Z",
    fill: "#69ab5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.265,20.799h6.628c.366,0,.663.297.663.663v23.859c0,.366-.297.663-.663.663h-6.628c-.366,0-.663-.297-.663-.663v-23.859c0-.366.297-.663.663-.663Z",
    fill: "#4d95eb"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.4bf31f09.svg";
export { ForwardRef as ReactComponent };